import React from 'react';

import styles from './styles';

const DotLoader = () => (
  <div className={ styles.dots }>
    <div className={ styles.item } />
    <div className={ styles.item } />
    <div className={ styles.item } />
    <div className={ styles.item } />
    <div className={ styles.item } />
  </div>
);

export default DotLoader;



// WEBPACK FOOTER //
// ./src/components/DotLoader/index.jsx